// extracted by mini-css-extract-plugin
export default {"root":"SectionPartners_root__YDPqW"};